const state = {
  initial: null,
  isLogin: null,
  isLoading: 0,
  isDialogLoading: 0,
  isUploading: undefined,
  routeReset: false,
  modal: {
    action: null,
    param: null,
    callback: null,
    height: null,
    width: null,
    closeButton: true,
    customStyles: {}
  },
  modal2: {
    action: null,
    param: null,
    callback: null,
    height: null,
    width: null,
    closeButton: true,
    customStyles: {}
  },
  toast: null,
  borCor: null,
  unloadAlert: 0,
  scrollState: {
    top: null,
    height: null
  },
  pageDisplayData: {},
  // const
  normalPage: [
    'main',
    'deviceAlert',
    'forget',
    'reset',
    'register',
    'active',
    'genePanel',
    'phenotypeDisease',
    'coverageRate',
    'datasetAccess',
    'datasetDetail'
  ],
  userPage: [
    'user',
    'workgroup',
    'panel',
    'point',
    'config',
    'systemInfo',
    'caseList',
    'caseEdit',
    'caseBatchUpload',
    'caseDetail',
    'datasetList',
    'datasetEdit',
    'datasetInvitationConfirm',
    'genomeBrowser',
    'tpehealthAPP'
  ],
  adminPage: [
  ]
}

const getters = {
  initial: state => state.initial,
  isLogin: state => state.isLogin,
  isLoading: state => state.isLoading > 0,
  isDialogLoading: state => state.isDialogLoading > 0,
  isUploading: state => state.isUploading,
  routeReset: state => state.routeReset,
  modal: state => state.modal,
  modal2: state => state.modal2,
  toast: state => state.toast,
  borCor: state => state.borCor,
  unloadAlert: state => state.unloadAlert,
  scrollState: state => state.scrollState,
  pageDisplayData: state => state.pageDisplayData,
  // const
  normalPage: state => state.normalPage,
  userPage: state => state.userPage,
  adminPage: state => state.adminPage
}

const types = {
  appInitial: 'app/appInitial',
  setLogin: 'app/setLogin',
  setLoading: 'app/setLoading',
  clearLoading: 'app/clearLoading',
  setDialogLoading: 'app/setDialogLoading',
  clearDialogLoading: 'app/clearDialogLoading',
  setUploading: 'app/setUploading',
  setRouteReset: 'app/setRouteReset',
  setModal: 'app/setModal',
  setModal2: 'app/setModal2',
  addToast: 'app/addToast',
  deleteToast: 'app/deleteToast',
  setUnloadAlert: 'app/setUnloadAlert',
  setScrollState: 'app/setScrollState',
  setPageDisplayData: 'app/setPageDisplayData'
}

const mutations = {
  [types.appInitial] (state, boolean) {
    state.initial = boolean
  },
  [types.setLogin] (state, boolean) {
    state.isLogin = boolean
  },
  [types.setLoading] (state, boolean) {
    if (boolean !== undefined) {
      if (boolean) {
        state.isLoading += 1
      } else {
        state.isLoading -= 1
      }
    }
  },
  [types.clearLoading] (state) {
    state.isLoading = 0
  },
  [types.setDialogLoading] (state, boolean) {
    if (boolean !== undefined) {
      if (boolean) {
        state.isDialogLoading += 1
      } else {
        state.isDialogLoading -= 1
      }
    }
  },
  [types.clearDialogLoading] (state) {
    state.isDialogLoading = 0
  },
  [types.setUploading] (state, content) {
    state.isUploading = content
  },
  [types.setRouteReset] (state, boolean) {
    state.routeReset = boolean
  },
  [types.setModal] (state, object) {
    state.modal = object
  },
  [types.setModal2] (state, object) {
    state.modal2 = object
  },
  [types.addToast] (state, object) {
    state.toast = { ...object }
  },
  [types.setBorCor] (state, object) {
    state.borCor = object
  },
  [types.setUnloadAlert] (state, boolean) {
    if (boolean !== undefined) {
      if (boolean) {
        state.unloadAlert += 1
      } else {
        state.unloadAlert -= 1
      }
    } else {
      state.unloadAlert = 0
    }
  },
  [types.setScrollState] (state, object) {
    state.scrollState = object
  },
  [types.setPageDisplayData] (state, object) {
    state.pageDisplayData = object
  }
}

const actions = {
  appInitialAction ({commit}, boolean) {
    commit(types.appInitial, boolean)
  },
  setLoginAction ({commit}, boolean) {
    commit(types.setLogin, boolean)
  },
  setLoadingAction ({commit}, boolean) {
    commit(types.setLoading, boolean)
  },
  clearLoadingAction ({commit}) {
    commit(types.clearLoading)
  },
  setDialogLoadingAction ({commit}, boolean) {
    commit(types.setDialogLoading, boolean)
  },
  clearDialogLoadingAction ({commit}) {
    commit(types.clearDialogLoading)
  },
  setUploadingAction ({commit}, content) {
    commit(types.setUploading, content)
  },
  setRouteResetAction ({commit}, boolean) {
    commit(types.setRouteReset, boolean)
  },
  setModalAction ({commit}, object) {
    commit(types.setModal, object)
  },
  setModal2Action ({commit}, object) {
    commit(types.setModal2, object)
  },
  addToastAction ({commit}, object) {
    commit(types.addToast, object)
  },
  setBorCorAction ({commit}, object) {
    commit(types.setBorCor, object)
  },
  setUnloadAlertAction ({commit}, boolean) {
    commit(types.setUnloadAlert, boolean)
  },
  setScrollStateAction ({commit}, object) {
    commit(types.setScrollState, object)
  },
  setPageDisplayDataAction ({commit}, boolean) {
    commit(types.setPageDisplayData, boolean)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js